import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui';

export const BasicInfo = () => {
  return (
    <div className='w-full space-y-1 px-4 pb-1'>
      {/* Stt */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Stt/Stt In</Label>
        <div className='flex items-center gap-2'>
          <FormField name='stt' type='number' className='w-16' />
          <FormField name='stt_in' type='number' className='w-16' />
        </div>
      </div>

      {/* Mã chỉ tiêu */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Mã chỉ tiêu/Mã in</Label>
        <div className='flex items-center gap-2'>
          <FormField name='ma_so' className='w-28' />
          <FormField name='ma_in' className='w-28' />
        </div>
      </div>

      {/* Tên chỉ tiêu */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Tên chỉ tiêu</Label>
        <div className='flex-1'>
          <FormField name='chi_tieu' />
        </div>
      </div>

      {/* Tên khác */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Tên khác</Label>
        <div className='flex-1'>
          <FormField name='chi_tieu2' />
        </div>
      </div>

      {/* Tên 3 */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Tên 3</Label>
        <div className='flex-1'>
          <FormField name='chi_tieu3' />
        </div>
      </div>

      {/* Thuyết minh */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Thuyết minh</Label>
        <div className='flex-1'>
          <FormField name='thuyet_minh' />
        </div>
      </div>

      {/* Phân loại */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>Phân loại</Label>
        <div className='w-40'>
          <FormField
            name='ts_nv'
            type='select'
            options={[
              { label: 'Tài sản', value: '1' },
              { label: 'Nguồn vốn', value: '2' }
            ]}
          />
        </div>
      </div>

      {/* In/Kiểu chữ */}
      <div className='flex items-center'>
        <Label className='mt-2 w-40 min-w-40 font-medium'>In/Kiểu chữ</Label>
        <div className='flex items-center gap-2'>
          <div className='w-40'>
            <FormField
              name='in_yn'
              type='select'
              options={[
                { label: 'Có', value: '1' },
                { label: 'Không', value: '0' }
              ]}
            />
          </div>
          <div className='w-40'>
            <FormField
              name='bold_yn'
              type='select'
              options={[
                { label: 'Đậm', value: '1' },
                { label: 'Không đậm', value: '0' }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
